import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';

import { Provider } from 'react-redux';
import { store } from './redux/application/redux-store';

// MSAL Instance Configuration
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from '@azure/msal-browser';
import { _msalConfig } from './providers/authentication/auth-provider';
import i18n from './providers/localization/localization-provider';
import reportWebVitals from './reportWebVitals';

import 'react-quill/dist/quill.snow.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';

export const msalInstance = new PublicClientApplication(_msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
	msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
	if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
		const payload = event.payload as AuthenticationResult;
		const account = payload.account;
		msalInstance.setActiveAccount(account);
	}
});

ReactDOM.render(
	<Provider store={store}>
		<I18nextProvider i18n={i18n}>
			<Router>
				<App msalInstance={msalInstance} />
			</Router>
		</I18nextProvider>
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();